/**
 * 国家和地区常量定义
 */

export interface Country {
  code: string;
  name: string;
  phoneCode: string;
}

export const COUNTRIES: Country[] = [
  // 中文地区
  { code: 'CN', name: '中国大陆', phoneCode: '+86' },
  { code: 'HK', name: '中国香港', phoneCode: '+852' },
  { code: 'TW', name: '中国台湾', phoneCode: '+886' },
  { code: 'MO', name: '中国澳门', phoneCode: '+853' },
  
  // 主要英语国家
  { code: 'US', name: '美国', phoneCode: '+1' },
  { code: 'CA', name: '加拿大', phoneCode: '+1' },
  { code: 'GB', name: '英国', phoneCode: '+44' },
  { code: 'AU', name: '澳大利亚', phoneCode: '+61' },
  { code: 'NZ', name: '新西兰', phoneCode: '+64' },
  { code: 'IE', name: '爱尔兰', phoneCode: '+353' },
  { code: 'SG', name: '新加坡', phoneCode: '+65' },
  { code: 'MY', name: '马来西亚', phoneCode: '+60' },
  { code: 'IN', name: '印度', phoneCode: '+91' },
  { code: 'PH', name: '菲律宾', phoneCode: '+63' },
  { code: 'ZA', name: '南非', phoneCode: '+27' },
  
  // 主要西班牙语国家
  { code: 'ES', name: '西班牙', phoneCode: '+34' },
  { code: 'MX', name: '墨西哥', phoneCode: '+52' },
  { code: 'AR', name: '阿根廷', phoneCode: '+54' },
  { code: 'CO', name: '哥伦比亚', phoneCode: '+57' },
  { code: 'PE', name: '秘鲁', phoneCode: '+51' },
  { code: 'VE', name: '委内瑞拉', phoneCode: '+58' },
  { code: 'CL', name: '智利', phoneCode: '+56' },
  { code: 'EC', name: '厄瓜多尔', phoneCode: '+593' },
  { code: 'GT', name: '危地马拉', phoneCode: '+502' },
  { code: 'CU', name: '古巴', phoneCode: '+53' },
  { code: 'BO', name: '玻利维亚', phoneCode: '+591' },
  { code: 'DO', name: '多米尼加', phoneCode: '+1' },
  { code: 'HN', name: '洪都拉斯', phoneCode: '+504' },
  { code: 'PY', name: '巴拉圭', phoneCode: '+595' },
  { code: 'SV', name: '萨尔瓦多', phoneCode: '+503' },
  { code: 'NI', name: '尼加拉瓜', phoneCode: '+505' },
  { code: 'CR', name: '哥斯达黎加', phoneCode: '+506' },
  { code: 'PA', name: '巴拿马', phoneCode: '+507' },
  { code: 'UY', name: '乌拉圭', phoneCode: '+598' },
  
  // 其他主要国家
  { code: 'JP', name: '日本', phoneCode: '+81' },
  { code: 'KR', name: '韩国', phoneCode: '+82' },
  { code: 'TH', name: '泰国', phoneCode: '+66' },
  { code: 'VN', name: '越南', phoneCode: '+84' },
  { code: 'ID', name: '印度尼西亚', phoneCode: '+62' },
  { code: 'BR', name: '巴西', phoneCode: '+55' },
  { code: 'FR', name: '法国', phoneCode: '+33' },
  { code: 'DE', name: '德国', phoneCode: '+49' },
  { code: 'IT', name: '意大利', phoneCode: '+39' },
  { code: 'RU', name: '俄罗斯', phoneCode: '+7' },
  { code: 'NL', name: '荷兰', phoneCode: '+31' },
  { code: 'BE', name: '比利时', phoneCode: '+32' },
  { code: 'CH', name: '瑞士', phoneCode: '+41' },
  { code: 'AT', name: '奥地利', phoneCode: '+43' },
  { code: 'SE', name: '瑞典', phoneCode: '+46' },
  { code: 'NO', name: '挪威', phoneCode: '+47' },
  { code: 'DK', name: '丹麦', phoneCode: '+45' },
  { code: 'FI', name: '芬兰', phoneCode: '+358' },
  { code: 'PL', name: '波兰', phoneCode: '+48' },
  { code: 'PT', name: '葡萄牙', phoneCode: '+351' },
  { code: 'GR', name: '希腊', phoneCode: '+30' },
  { code: 'TR', name: '土耳其', phoneCode: '+90' },
  { code: 'IL', name: '以色列', phoneCode: '+972' },
  { code: 'AE', name: '阿联酋', phoneCode: '+971' },
  { code: 'SA', name: '沙特阿拉伯', phoneCode: '+966' },
  { code: 'EG', name: '埃及', phoneCode: '+20' },
  { code: 'NG', name: '尼日利亚', phoneCode: '+234' },
  { code: 'KE', name: '肯尼亚', phoneCode: '+254' },
  { code: 'GH', name: '加纳', phoneCode: '+233' },
];

/**
 * 根据国家代码获取国家信息
 */
export function getCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find(country => country.code === code.toUpperCase());
}

/**
 * 根据国家代码获取电话国家代码
 */
export function getPhoneCodeByCountry(countryCode: string): string {
  const country = getCountryByCode(countryCode);
  return country?.phoneCode || '+86';
}

/**
 * 获取所有国家代码列表
 */
export function getCountryCodes(): string[] {
  return COUNTRIES.map(country => country.code);
}

/**
 * 按地区分组的国家列表
 */
export const COUNTRIES_BY_REGION = {
  chinese: COUNTRIES.filter(c => ['CN', 'HK', 'TW', 'MO'].includes(c.code)),
  english: COUNTRIES.filter(c => ['US', 'CA', 'GB', 'AU', 'NZ', 'IE', 'SG', 'MY', 'IN', 'PH', 'ZA'].includes(c.code)),
  spanish: COUNTRIES.filter(c => ['ES', 'MX', 'AR', 'CO', 'PE', 'VE', 'CL', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'CR', 'PA', 'UY'].includes(c.code)),
  others: COUNTRIES.filter(c => !['CN', 'HK', 'TW', 'MO', 'US', 'CA', 'GB', 'AU', 'NZ', 'IE', 'SG', 'MY', 'IN', 'PH', 'ZA', 'ES', 'MX', 'AR', 'CO', 'PE', 'VE', 'CL', 'EC', 'GT', 'CU', 'BO', 'DO', 'HN', 'PY', 'SV', 'NI', 'CR', 'PA', 'UY'].includes(c.code))
};